import React, { Component } from "react";
import { update } from "../utils/apiService";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { object, func } from "prop-types";
import { Glyphicon, Tooltip, OverlayTrigger } from "react-bootstrap";

// actions
import { updateVideo } from "../actions";

class VideoTitleEditable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: this.props.video.title,
      showing: true,
      editing: false,
      saving: false
    };

    this._handleKeyPress = this._handleKeyPress.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.saveTitle = this.saveTitle.bind(this);
  }
  _handleKeyPress(e) {
    if (e.key === "Enter") {
      this.saveTitle();
    }
  }
  handleInput(e) {
    this.setState({
      title: e.target.value
    });
  }
  saveTitle() {
    const { video } = this.props;
    if (this.state.title === video.title) {
      this.setState({
        showing: true,
        editing: false
      });
      return;
    }
    this.setState({
      saving: true
    });
    let url = `/campaigns/${video.campaign_id}/videos/${video.id}`;
    let data = {
      video: {
        title: this.state.title
      }
    };
    update(url, data)
      .then(res => {
        let newVideo = res.data;
        this.props.updateVideo(video.campaign_id, newVideo);
        this.setState({
          showing: true,
          saving: false,
          editing: false
        });
        toastr.success("Título atualizado com sucesso!");
      })
      .catch(err => {
        this.setState({
          showing: false,
          editing: true,
          saving: false
        });
        toastr.error("Ocorreu um erro. Tente novamente");
      });
  }
  render() {
    const tooltip = <Tooltip id="tooltip">Clique para editar</Tooltip>;
    return (
      <div>
        {this.state.showing && (
          <OverlayTrigger placement="top" overlay={tooltip}>
            <span
              className="editable"
              onClick={() => {
                let title = this.state.title;
                this.setState({ showing: false, editing: true, title: "" }, () => this.setState({ title: title }));
              }}
              style={{ float: "left" }}
            >
              {this.state.title}{" "}
              <small className="editable-pencil">
                <Glyphicon glyph="pencil" />
              </small>
            </span>
          </OverlayTrigger>
        )}
        {this.state.editing && (
          <input
            style={{ fontSize: "28px" }}
            className="form-control"
            type="text"
            value={this.state.title}
            onChange={this.handleInput}
            onBlur={this.saveTitle}
            onKeyPress={this._handleKeyPress}
            disabled={this.state.saving}
            autoFocus
          />
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateVideo: (campaignId, video) => {
      dispatch(updateVideo(campaignId, video));
    }
  };
};

VideoTitleEditable.propTypes = {
  video: object,
  updateVideo: func
};

export default connect(null, mapDispatchToProps)(VideoTitleEditable);



// WEBPACK FOOTER //
// ./src/components/VideoTitleEditable.js